import {Component, Inject, ViewChild} from '@angular/core';
import {UiConstants} from '../../../util/core-utils';
import {InputMask} from '../../../util/input-masks';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {ForwardingNgFormRef, LocalFormGroupValidationErrors} from '../../../lib/util/services';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {NgbDatePickerParserFormatter} from '../../../util/ngb-datepicker';
import {ContractNumber, ContractNumberService} from "../../../lib/customer/contract-number/contract-number.service";

@Component({
  selector: 'app-contract-number-create-dialog',
  templateUrl: './contract-number-create-dialog.component.html',
  styleUrls: ['./contract-number-create-dialog.component.scss']
})
export class ContractNumberCreateDialogComponent {

  UiConstants = UiConstants;
  InputMask = InputMask;

  @ViewChild('f', {static: true})
  form: NgForm;
  formGroup: FormGroup;
  private formGroupValidationErrors: LocalFormGroupValidationErrors;

  model: ContractNumberCreateModel = new ContractNumberCreateModel();

  constructor(public dialogRef: MatDialogRef<ContractNumberCreateDialogComponent>,
              private translateService: TranslateService,
              private datePickerParserFormatter: NgbDatePickerParserFormatter,
              private fb: FormBuilder,
              private contractNumberService: ContractNumberService,
              @Inject(MAT_DIALOG_DATA) public data: ContractNumberCreateDialogData) {
    this.loadModel();
    this.formGroup = this.createFormGroup(this.fb);
    this.formGroupValidationErrors = LocalFormGroupValidationErrors.ofForm(
      this.createForwardingHtmlForm(),
      this.formGroup
    );
  }

  public static openDialog(
    dialog: MatDialog,
    data: ContractNumberCreateDialogData,
    resultCallback: (result?: ContractNumberCreateDialogResult) => void) {
    const dialogRef = dialog.open(ContractNumberCreateDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((result: ContractNumberCreateDialogResult) => {
      resultCallback(result);
    });
  }

  closeDialog(contractNumber?: ContractNumber.ContractNumber) {
    this.dialogRef.close({contractNumber: contractNumber});
  }

  save() {
    if (this.hasLocalFieldError()) {
      return;
    } else {
      this.createContractNumber();
    }
  }

  private createForwardingHtmlForm() {
    return new ForwardingNgFormRef({
      formFn: () => {
        return this.form;
      }
    });
  }

  private createFormGroup(fb: FormBuilder): FormGroup {
    return fb.group(
      {
        contractNumber: fb.control(
          {value: this.model.contractNumber},
          [Validators.required]
        ),
      }
    );
  }

  hasLocalFieldError(formControlName?: string, errorCode?: string): boolean {
    return this.formGroupValidationErrors.hasFieldError(formControlName, errorCode);
  }

  createContractNumber() {
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.invalid) {
      return;
    }
    this.contractNumberService.create({
      contractNumber: this.model.contractNumber,
      fields: field => field.forList
    }).subscribe(
      (result: ContractNumber.ContractNumber) => {
        this.closeDialog(result);
      },
      error => {

      });
  }

  private loadModel() {
    this.model = new ContractNumberCreateModel();
  }

}

export class ContractNumberCreateModel {
  contractNumber: string = '';
}

export class ContractNumberCreateDialogData {
}

export class ContractNumberCreateDialogResult {
  contractNumber?: ContractNumber.ContractNumber;
}
